<template>
  <div class="sm:py-4">
    <div
      v-if="sent"
      class="p-4 sm:rounded sm:shadow sm:max-w-screen-sm mx-auto bg-white"
    >
      <h1>Message Received</h1>
      <p class="font-light text-2xl">Thanks, we'll get back to you soon.</p>
    </div>
    <form
      v-else
      class="p-4 sm:rounded sm:shadow sm:max-w-screen-sm mx-auto bg-white"
      @submit.prevent="submitYo"
    >
      <h1>Please give us your feedback!</h1>
      <p class="font-light text-2xl">
        Have questions or comments about the site? Submit them here, and we'll
        get back to you soon.
      </p>
      <mdc-textarea v-model="body" class="w-full" label="Comments..." />
      <mdc-select
        v-if="account"
        v-model="account"
        :options="$store.state.user.accounts"
        class="my-2"
        value-key="hash"
        label-key="email"
        label="Reply to"
        dense
      >
        <template slot="option" slot-scope="props">
          {{ props.option.name }} &lt;{{ props.option.email }}&gt;
        </template>
      </mdc-select>
      <div class="text-right">
        <mdc-button ripple raised @click.prevent.native="submitYo(false)">
          Submit
        </mdc-button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from '@/utils/xhr';
import MdcButton from '@/components/mdc/button.vue';
import MdcSelect from '@/components/mdc/select.vue';
import MdcTextarea from '@/components/mdc/textarea.vue';

export default {
  components: {
    MdcButton,
    MdcSelect,
    MdcTextarea,
  },

  data: () => ({
    body: '',
    account: null,
    sent: false,
  }),

  mounted() {
    [this.account] = this.$store.state.user.accounts;
  },

  methods: {
    submitYo() {
      axios
        .post('/contact-us', { body: this.body, account: this.account.hash })
        .then(() => {
          this.sent = true;
        });
    },
  },
};
</script>
